(function (global) {
  const MONTHS = {
    jan: 0,
    january: 0,
    feb: 1,
    february: 1,
    mar: 2,
    march: 2,
    apr: 3,
    april: 3,
    may: 4,
    jun: 5,
    june: 5,
    jul: 6,
    july: 6,
    aug: 7,
    august: 7,
    sep: 8,
    sept: 8,
    september: 8,
    oct: 9,
    october: 9,
    nov: 10,
    november: 10,
    dec: 11,
    december: 11,
  };

  const WEEKDAYS = new Set([
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ]);

  function startOfDay(date) {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
  }

  function parseWorkshopLabel(label, year) {
    if (!label) return null;
    const cleaned = String(label)
      .replace(/\u202f/g, ' ')
      .replace(/,/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (!cleaned) return null;

    if (/^\d{4}-\d{2}-\d{2}/.test(cleaned)) {
      const d = new Date(cleaned.slice(0, 10) + 'T12:00:00');
      return isNaN(d.getTime()) ? null : d;
    }

    const tokens = cleaned
      .split(' ')
      .map((t) => t.trim())
      .filter((t) => t && !WEEKDAYS.has(t.toLowerCase()));

    if (tokens.length < 2) return null;

    let day;
    let month;
    if (/^\d{1,2}$/.test(tokens[0])) {
      day = parseInt(tokens[0], 10);
      month = MONTHS[tokens[1].toLowerCase()];
    } else {
      month = MONTHS[tokens[0].toLowerCase()];
      day = parseInt(tokens[1], 10);
    }

    if (month == null || !day || day < 1 || day > 31) return null;
    const d = new Date(year, month, day, 12, 0, 0, 0);
    return isNaN(d.getTime()) ? null : d;
  }

  function collectLabels(el) {
    const labels = [];
    const raw =
      el.getAttribute('data-workshop-date-labels') ||
      el.querySelector('[data-workshop-date-labels]')?.getAttribute('data-workshop-date-labels') ||
      '';
    raw.split('|').forEach((label) => {
      const trimmed = label.trim();
      if (trimmed) labels.push(trimmed);
    });

    const variantsJson =
      el.getAttribute('data-product-variants') ||
      el.querySelector('[data-product-variants]')?.getAttribute('data-product-variants');
    if (variantsJson) {
      try {
        const variants = JSON.parse(variantsJson);
        variants.forEach((variant) => {
          const option1 = variant?.option1 || variant?.raw;
          if (option1 && !labels.includes(option1)) labels.push(option1);
        });
      } catch (e) {
        /* invalid variant json */
      }
    }
    return labels;
  }

  function pickSortDate(candidates, now) {
    if (!candidates.length) return null;
    const today = startOfDay(now);
    const upcoming = candidates.filter((d) => d >= today).sort((a, b) => a - b);
    if (upcoming.length) return upcoming[0];
    return candidates.slice().sort((a, b) => a - b)[0];
  }

  function resolveSortDate(el, now) {
    const reference = now || new Date();
    const year = reference.getFullYear();
    const candidates = [];

    const attr =
      el.getAttribute('data-workshop-sort-date') ||
      el.querySelector('[data-workshop-sort-date]')?.getAttribute('data-workshop-sort-date');
    if (attr) {
      const fromAttr = parseWorkshopLabel(attr, year);
      if (fromAttr) candidates.push(fromAttr);
    }

    collectLabels(el).forEach((label) => {
      const parsed = parseWorkshopLabel(label, year);
      if (parsed) candidates.push(parsed);
    });

    return pickSortDate(candidates, reference);
  }

  function isWaitlist(el) {
    return (
      el.getAttribute('data-workshop-waitlist') === 'true' ||
      el.querySelector('[data-workshop-waitlist="true"]') != null
    );
  }

  function workshopSortTitle(el) {
    if (!el) return '';
    return String(
      el.getAttribute('data-product-title') ||
        el.querySelector('[data-product-title]')?.getAttribute('data-product-title') ||
        el.querySelector('.x-card-title')?.textContent ||
        el.getAttribute('aria-label') ||
        ''
    )
      .trim()
      .toLowerCase();
  }

  function compareWorkshopItems(a, b, direction, now) {
    const dir = direction == null ? 1 : direction;
    const aWait = isWaitlist(a);
    const bWait = isWaitlist(b);
    if (aWait && !bWait) return 1;
    if (!aWait && bWait) return -1;

    const dateA = resolveSortDate(a, now);
    const dateB = resolveSortDate(b, now);
    const today = startOfDay(now);
    const aPast = !dateA || dateA < today;
    const bPast = !dateB || dateB < today;
    if (aPast && !bPast) return 1;
    if (!aPast && bPast) return -1;
    if (!dateA && !dateB) {
      return workshopSortTitle(a).localeCompare(workshopSortTitle(b), undefined, {
        sensitivity: 'base',
      });
    }
    if (!dateA) return 1;
    if (!dateB) return -1;
    if (dateA - dateB !== 0) return (dateA - dateB) * dir;
    return workshopSortTitle(a).localeCompare(workshopSortTitle(b), undefined, {
      sensitivity: 'base',
    });
  }

  global.WorkshopDateUtils = {
    startOfDay,
    parseWorkshopLabel,
    resolveSortDate,
    isWaitlist,
    compareWorkshopItems,
  };
})(window);
